export const defaultTheme = {
    colors: {
        primaryA700: '#2A57AC',
        primaryA800: '#0D3F78',
        primaryA600: '#2972C4',
        primaryA200: '#8FC3FF',
        primaryA50: '#D0DCF0',
        primaryA10: '#E0E5EF',
        primaryB700: '#B1101E',
        primaryP200: '#5899E5',
        primaryP50: '#DCECFF',
        active400: '#A78BFA',
        black900: '#1D1E21',
        black800: '#212121',
        black700: '#424448',
        black650: '#545454',
        black600: '#76777A',
        black500: '#8C8C8C',
        black450: '#ABABAB',
        black400: '#DBDBDB',
        black350: '#d9d9d9',
        black300: '#EDEDED',
        black200: '#F6F6F6',
        information800: '#2972C4',
        information700: '#2A57AC',
        information600: '#0D3F78',
        information500: '#2869B5',
        information200: '#8FC3FF',
        information50: '#D0DCF0',
        information10: '#E0E5EF',
        warning400: '#FBBF24',
        warning500: '#FAAD14',
        warning300: '#FFD666',
        warning200: '#FFE58F',
        warning50: '#FFFBE6',
        success800: '#006631',
        success900: '#00401F',
        success700: '#078C47',
        success300: '#10B981',
        success200: '#81E8B3',
        success100: '#BDD289',
        success50: '#E6FFF2',
        danger700: '#B1101E',
        danger800: '#8A000B',
        danger600: '#D61E2D',
        danger200: '#FF9FA7',
        danger50: '#FFF0F1',
    },
    breakpoint: {
        xs: '0',
        sm: '600px',
        md: '840px',
        lg: '1024px',
        xl: '1280px',
        xxl: '1440px',
        xxxl: '1880px',
    },
    shadow: {
        100: '0 1px 3px rgba(0, 0, 0, 0.07), 0 1px 2px rgba(0, 0, 0, 0.14)',
        200: '0 3px 6px rgba(0, 0, 0, 0.10), 0 3px 6px rgba(0, 0, 0, 0.14)',
        300: '0 10px 20px rgba(0, 0, 0, 0.12), 0 6px 6px rgba(0, 0, 0, 0.14)',
        400: '0 14px 28px rgba(0, 0, 0, 0.16), 0 10px 10px rgba(0, 0, 0, 0.14)',
    },
    transition: {
        normal: '300ms',
        slow: '400ms',
    },
    margin: {
        base: '12px',
    },
    padding: {
        base: '12px',
    },
    borderRadius: {
        base: '6px',
    },
    typography: {
        titleExtraLarge: {
            fontSize: '40px',
            fontWeight: 600,
        },
        titleLarge: {
            fontSize: '30px',
            fontWeight: 700,
        },
        titleRegular: {
            fontSize: '28px',
            fontWeight: 600,
        },
        titleSmall: {
            fontSize: '23px',
            fontWeight: 600,
        },
        titleExtraSmall: {
            fontSize: '19px',
            fontWeight: 600,
        },
        titleMicro: {
            fontSize: '14px',
            fontWeight: 600,
        },
        heading: {
            fontSize: '19px',
            fontWeight: 500,
        },
        headingSmall: {
            fontSize: '16px',
            fontWeight: 500,
        },
        headingExtraSmall: {
            fontSize: '13.5px',
            fontWeight: 500,
        },
        headingMicro: {
            fontSize: '12px',
            fontWeight: 500,
        },
        bodyLarge: {
            fontSize: '19px',
            fontWeight: 400,
        },
        bodyRegular: {
            fontSize: '16px',
            fontWeight: 400,
        },
        bodySmall: {
            fontSize: '13.5px',
            fontWeight: 400,
        },
        bodyExtraSmall: {
            fontSize: '12px',
            fontWeight: 400,
        },
        button: {
            fontSize: '13.5px',
            fontWeight: 500,
        },
        status: {
            fontSize: '12px',
            fontWeight: 500,
        },
    },
};
